export const isTestHost = () => {
  const host = window.location.host
  if (
    host.includes('localhost') ||
    host.includes('test.id-pay.ru') ||
    host.includes('dev2.id-pay.ru')
  ) {
    return true
  }
  return false
}

export const getHostKey = () => {
  const host = window.location.host
  return host.split('.')[0]
}

export const isProdHost = () => {
  const host = window.location.host
  if (host.includes('id-pay.ru')) {
    return true
  }
  return false
}
